'use strict';

var ToUint8 = require('./ToUint8');

// https://ecma-international.org/ecma-262/6.0/#sec-toint8

module.exports = function ToInt8(argument) {
	var int8bit = ToUint8(argument);
	return int8bit >= 0x80 ? int8bit - 0x100 : int8bit;
};



//////////////////
// WEBPACK FOOTER
// ./~/es-abstract/2016/ToInt8.js
// module id = 1331
// module chunks = 0